(function () {

    "use strict";

    angular
        .module("apiManager")
        .service("hAPIService", function () {
            var self = this;

            var apis = {};

            self.registerAPI = function (apiName, apiCtrl) {
                apis[apiName] = apiCtrl;
            };

            self.getAPI = function (apiName) {
                return new (function () {
                    var api = this;

                    var functionArgs = [];

                    for (var i in arguments) {
                        functionArgs.push(arguments[i]);
                    }

                    functionArgs.shift();

                    BaseAPI.apply(api, []);
                    apis[apiName].apply(api, functionArgs);
                });
            };
        });
})();